import "core-js/modules/es.json.parse.js";
import Vue from "vue";
import * as Sentry from "@sentry/vue";
Vue.use(Sentry);
console.log("environment", process.env.VUE_APP_MODE);
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_MODE === "production" ? "https://c0e196ee4788c55e86880df5d9f91d40@sentry-api.wenwo.com/2" : "https://c0e196ee4788c55e86880df5d9f91d40@sentry.wenwo.com/2",
  sendDefaultPii: true,
  release: `m_saas_business_admin@1.0.0`,
  environment: process.env.VUE_APP_MODE || "development",
  tracesSampleRate: 1.0,
  //   debug: true,
  beforeSend: event => {
    const userInfoStorage = localStorage.getItem("aiwen_user_userinfo_new");
    const comtyInfoStorage = localStorage.getItem("aiwen_user_comtyinfo_new");
    let userInfo = userInfoStorage ? JSON.parse(userInfoStorage) : {};
    let comtyInfo = comtyInfoStorage ? JSON.parse(comtyInfoStorage) : {};
    if (!event.user) {
      event.user = {
        userId: userInfo.userId || "",
        communityId: comtyInfo.communityId || ""
      };
    }
    return event;
  }
});